import FirstPage from 'components/Icons/FirstPage';
import LastPage from 'components/Icons/LastPage';
import NextPage from 'components/Icons/NextPage';
import PreviousPage from 'components/Icons/PreviousPage';
import { History } from 'history';
import React from 'react';
import { Sheet } from 'records/Sheet';
import { SheetVersion } from 'records/SheetVersion';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';
import ViewerFooterDownload from './ViewerFooterDownload';

interface Props extends WithAppStoreProps {
  sheet: Sheet;
  history: History;
}

const ViewerFooter = (props: Props) => {
  const { appState, history, actions, sheet } = props;
  const { translate } = useTranslator(['editorPage']);

  const handleFirstPageClick = (): void => {
    const { queriedSheets } = appState;

    actions.clearInteractions();

    const firstSheetId = queriedSheets.toIndexedSeq().first<string>();

    history.push(
      `/project/${appState.selectedProject}/sheet/${firstSheetId}/view`
    );
  };

  const handlePreviousPageClick = (): void => {
    const { sheets, queriedSheets } = appState;

    actions.clearInteractions();

    const indexedSheets = queriedSheets.toIndexedSeq();

    // zero-indexed
    const nextSheetIndex = indexedSheets.indexOf(sheet.sheetid) - 1;

    const previousSheetId = indexedSheets.get(nextSheetIndex, '');

    const previousSheet = sheets.get(previousSheetId, new Sheet());

    if (previousSheet.versions.size === 0) {
      return;
    }

    history.push(
      `/project/${appState.selectedProject}/sheet/${previousSheet.sheetid}/view`
    );
  };

  const handleNextPageClick = (): void => {
    const { sheets, queriedSheets } = appState;

    actions.clearInteractions();

    const indexedSheets = queriedSheets.toIndexedSeq();

    // zero-indexed
    const nextSheetIndex = queriedSheets.indexOf(sheet.sheetid) + 1;

    const nextSheetId = indexedSheets.get(nextSheetIndex, '');

    const nextSheet = sheets.get(nextSheetId, new Sheet());

    if (nextSheet.versions.size === 0) {
      return;
    }

    history.push(
      `/project/${appState.selectedProject}/sheet/${nextSheet.sheetid}/view`
    );
  };

  const handleLastSheetClick = (): void => {
    const { queriedSheets } = appState;

    actions.clearInteractions();

    const lastSheetId = queriedSheets.toIndexedSeq().last<string>();

    history.push(
      `/project/${appState.selectedProject}/sheet/${lastSheetId}/view`
    );
  };
  const { queriedSheets } = appState;

  // Non zero-indexed.
  const sheetOrderLocation =
    queriedSheets.toIndexedSeq().indexOf(sheet.sheetid) + 1;

  const sheetVersion = sheet.versions.last<SheetVersion>();

  return (
    <div className="hs3 w100 bt-1 flex justify-between shrink-0">
      <div className="ws9 flex items-center">
        <div className="ml3">
          <ViewerFooterDownload sheetVersion={sheetVersion} />
        </div>
      </div>
      <div className="row items-center justify-center fill-gray-7">
        <div
          className="mr4 fill-black-h cursor-pointer"
          onClick={handleFirstPageClick}
        >
          <div className="wrem-2 hrem-2 flex-center">
            <FirstPage width="22px" height="20px" />
          </div>
        </div>
        <div
          className="fill-black-h cursor-pointer"
          onClick={handlePreviousPageClick}
        >
          <div className="wrem-2 hrem-2 flex-center">
            <PreviousPage width="17px" height="20px" />
          </div>
        </div>
        <div className="font-size-4 color-gray-6 mx3 nowrap">
          {translate('editorPage:currentSheetOfAll', {
            currentSheet: sheetOrderLocation,
            allSheetsCount: queriedSheets.size,
          })}
        </div>
        <div
          className="mr4 fill-black-h cursor-pointer"
          onClick={handleNextPageClick}
        >
          <div className="wrem-2 hrem-2 flex-center">
            <NextPage width="17px" height="20px" />
          </div>
        </div>
        <div
          className="fill-black-h cursor-pointer"
          onClick={handleLastSheetClick}
        >
          <div className="wrem-2 hrem-2 flex-center">
            <LastPage width="22px" height="20px" />
          </div>
        </div>
      </div>
      <div className="noop-spacer ws9" />
    </div>
  );
};

export default withAppStore<Props>(ViewerFooter);
